import { defineComponent as V, ref as R, computed as m, provide as Q, onMounted as M, watch as K, h as z, Fragment as W, onUnmounted as G, watchEffect as J, nextTick as B, toRaw as S, inject as X } from "vue";
import { useControllable as Y } from "./index325.js";
import { useId as j } from "./index327.js";
import { useOutsideClick as Z } from "./index328.js";
import { useResolveButtonType as _ } from "./index329.js";
import { useTextValue as $ } from "./index357.js";
import { useTrackedPointer as ee } from "./index330.js";
import { Hidden as te, Features as le } from "./index332.js";
import { useOpenClosedProvider as ae, useOpenClosed as oe, State as E } from "./index333.js";
import { Keys as f } from "./index334.js";
import { calculateActiveIndex as ie, Focus as g } from "./index337.js";
import { dom as x } from "./index339.js";
import { isFocusableElement as ne, FocusableMode as ue, sortByDomNode as re } from "./index340.js";
import { objectToFormEntries as se } from "./index341.js";
import { match as k } from "./index342.js";
import { compact as de, render as A, omit as ve, Features as U } from "./index345.js";
function pe(t, b) {
  return t === b;
}
var ce = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(ce || {}), fe = ((t) => (t[t.Single = 0] = "Single", t[t.Multi = 1] = "Multi", t))(fe || {}), be = ((t) => (t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))(be || {});
function me(t) {
  requestAnimationFrame(() => requestAnimationFrame(t));
}
let H = Symbol("ListboxContext");
function F(t) {
  let b = X(H, null);
  if (b === null) {
    let y = new Error(`<${t} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(y, F), y;
  }
  return b;
}
let Ve = V({ name: "Listbox", emits: { "update:modelValue": (t) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => pe }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(t, { slots: b, attrs: y, emit: h }) {
  let r = R(1), s = R(null), e = R(null), v = R(null), d = R([]), p = R(""), c = R(null), a = R(1);
  function i(l = (o) => o) {
    let o = c.value !== null ? d.value[c.value] : null, n = re(l(d.value.slice()), (O) => x(O.dataRef.domRef)), u = o ? n.indexOf(o) : null;
    return u === -1 && (u = null), { options: n, activeOptionIndex: u };
  }
  let P = m(() => t.multiple ? 1 : 0), [w, L] = Y(m(() => t.modelValue), (l) => h("update:modelValue", l), m(() => t.defaultValue)), D = m(() => w.value === void 0 ? k(P.value, { 1: [], 0: void 0 }) : w.value), T = { listboxState: r, value: D, mode: P, compare(l, o) {
    if (typeof t.by == "string") {
      let n = t.by;
      return l?.[n] === o?.[n];
    }
    return t.by(l, o);
  }, orientation: m(() => t.horizontal ? "horizontal" : "vertical"), labelRef: s, buttonRef: e, optionsRef: v, disabled: m(() => t.disabled), options: d, searchQuery: p, activeOptionIndex: c, activationTrigger: a, closeListbox() {
    t.disabled || r.value !== 1 && (r.value = 1, c.value = null);
  }, openListbox() {
    t.disabled || r.value !== 0 && (r.value = 0);
  }, goToOption(l, o, n) {
    if (t.disabled || r.value === 1) return;
    let u = i(), O = ie(l === g.Specific ? { focus: g.Specific, id: o } : { focus: l }, { resolveItems: () => u.options, resolveActiveIndex: () => u.activeOptionIndex, resolveId: (C) => C.id, resolveDisabled: (C) => C.dataRef.disabled });
    p.value = "", c.value = O, a.value = n ?? 1, d.value = u.options;
  }, search(l) {
    if (t.disabled || r.value === 1) return;
    let o = p.value !== "" ? 0 : 1;
    p.value += l.toLowerCase();
    let n = (c.value !== null ? d.value.slice(c.value + o).concat(d.value.slice(0, c.value + o)) : d.value).find((O) => O.dataRef.textValue.startsWith(p.value) && !O.dataRef.disabled), u = n ? d.value.indexOf(n) : -1;
    u === -1 || u === c.value || (c.value = u, a.value = 1);
  }, clearSearch() {
    t.disabled || r.value !== 1 && p.value !== "" && (p.value = "");
  }, registerOption(l, o) {
    let n = i((u) => [...u, { id: l, dataRef: o }]);
    d.value = n.options, c.value = n.activeOptionIndex;
  }, unregisterOption(l) {
    let o = i((n) => {
      let u = n.findIndex((O) => O.id === l);
      return u !== -1 && n.splice(u, 1), n;
    });
    d.value = o.options, c.value = o.activeOptionIndex, a.value = 1;
  }, theirOnChange(l) {
    t.disabled || L(l);
  }, select(l) {
    t.disabled || L(k(P.value, { 0: () => l, 1: () => {
      let o = S(T.value.value).slice(), n = S(l), u = o.findIndex((O) => T.compare(n, S(O)));
      return u === -1 ? o.push(n) : o.splice(u, 1), o;
    } }));
  } };
  Z([e, v], (l, o) => {
    var n;
    T.closeListbox(), ne(o, ue.Loose) || (l.preventDefault(), (n = x(e)) == null || n.focus());
  }, m(() => r.value === 0)), Q(H, T), ae(m(() => k(r.value, { 0: E.Open, 1: E.Closed })));
  let I = m(() => {
    var l;
    return (l = x(e)) == null ? void 0 : l.closest("form");
  });
  return M(() => {
    K([I], () => {
      if (!I.value || t.defaultValue === void 0) return;
      function l() {
        T.theirOnChange(t.defaultValue);
      }
      return I.value.addEventListener("reset", l), () => {
        var o;
        (o = I.value) == null || o.removeEventListener("reset", l);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: l, modelValue: o, disabled: n, form: u, ...O } = t, C = { open: r.value === 0, disabled: n, value: D.value };
    return z(W, [...l != null && D.value != null ? se({ [l]: D.value }).map(([N, q]) => z(te, de({ features: le.Hidden, key: N, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: u, disabled: n, name: N, value: q }))) : [], A({ ourProps: {}, theirProps: { ...y, ...ve(O, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: C, slots: b, attrs: y, name: "Listbox" })]);
  };
} });
V({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(t, { attrs: b, slots: y }) {
  var h;
  let r = (h = t.id) != null ? h : `headlessui-listbox-label-${j()}`, s = F("ListboxLabel");
  function e() {
    var v;
    (v = x(s.buttonRef)) == null || v.focus({ preventScroll: !0 });
  }
  return () => {
    let v = { open: s.listboxState.value === 0, disabled: s.disabled.value }, { ...d } = t, p = { id: r, ref: s.labelRef, onClick: e };
    return A({ ourProps: p, theirProps: d, slot: v, attrs: b, slots: y, name: "ListboxLabel" });
  };
} });
let Ae = V({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(t, { attrs: b, slots: y, expose: h }) {
  var r;
  let s = (r = t.id) != null ? r : `headlessui-listbox-button-${j()}`, e = F("ListboxButton");
  h({ el: e.buttonRef, $el: e.buttonRef });
  function v(a) {
    switch (a.key) {
      case f.Space:
      case f.Enter:
      case f.ArrowDown:
        a.preventDefault(), e.openListbox(), B(() => {
          var i;
          (i = x(e.optionsRef)) == null || i.focus({ preventScroll: !0 }), e.value.value || e.goToOption(g.First);
        });
        break;
      case f.ArrowUp:
        a.preventDefault(), e.openListbox(), B(() => {
          var i;
          (i = x(e.optionsRef)) == null || i.focus({ preventScroll: !0 }), e.value.value || e.goToOption(g.Last);
        });
        break;
    }
  }
  function d(a) {
    switch (a.key) {
      case f.Space:
        a.preventDefault();
        break;
    }
  }
  function p(a) {
    e.disabled.value || (e.listboxState.value === 0 ? (e.closeListbox(), B(() => {
      var i;
      return (i = x(e.buttonRef)) == null ? void 0 : i.focus({ preventScroll: !0 });
    })) : (a.preventDefault(), e.openListbox(), me(() => {
      var i;
      return (i = x(e.optionsRef)) == null ? void 0 : i.focus({ preventScroll: !0 });
    })));
  }
  let c = _(m(() => ({ as: t.as, type: b.type })), e.buttonRef);
  return () => {
    var a, i;
    let P = { open: e.listboxState.value === 0, disabled: e.disabled.value, value: e.value.value }, { ...w } = t, L = { ref: e.buttonRef, id: s, type: c.value, "aria-haspopup": "listbox", "aria-controls": (a = x(e.optionsRef)) == null ? void 0 : a.id, "aria-expanded": e.listboxState.value === 0, "aria-labelledby": e.labelRef.value ? [(i = x(e.labelRef)) == null ? void 0 : i.id, s].join(" ") : void 0, disabled: e.disabled.value === !0 ? !0 : void 0, onKeydown: v, onKeyup: d, onClick: p };
    return A({ ourProps: L, theirProps: w, slot: P, attrs: b, slots: y, name: "ListboxButton" });
  };
} }), Fe = V({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(t, { attrs: b, slots: y, expose: h }) {
  var r;
  let s = (r = t.id) != null ? r : `headlessui-listbox-options-${j()}`, e = F("ListboxOptions"), v = R(null);
  h({ el: e.optionsRef, $el: e.optionsRef });
  function d(a) {
    switch (v.value && clearTimeout(v.value), a.key) {
      case f.Space:
        if (e.searchQuery.value !== "") return a.preventDefault(), a.stopPropagation(), e.search(a.key);
      case f.Enter:
        if (a.preventDefault(), a.stopPropagation(), e.activeOptionIndex.value !== null) {
          let i = e.options.value[e.activeOptionIndex.value];
          e.select(i.dataRef.value);
        }
        e.mode.value === 0 && (e.closeListbox(), B(() => {
          var i;
          return (i = x(e.buttonRef)) == null ? void 0 : i.focus({ preventScroll: !0 });
        }));
        break;
      case k(e.orientation.value, { vertical: f.ArrowDown, horizontal: f.ArrowRight }):
        return a.preventDefault(), a.stopPropagation(), e.goToOption(g.Next);
      case k(e.orientation.value, { vertical: f.ArrowUp, horizontal: f.ArrowLeft }):
        return a.preventDefault(), a.stopPropagation(), e.goToOption(g.Previous);
      case f.Home:
      case f.PageUp:
        return a.preventDefault(), a.stopPropagation(), e.goToOption(g.First);
      case f.End:
      case f.PageDown:
        return a.preventDefault(), a.stopPropagation(), e.goToOption(g.Last);
      case f.Escape:
        a.preventDefault(), a.stopPropagation(), e.closeListbox(), B(() => {
          var i;
          return (i = x(e.buttonRef)) == null ? void 0 : i.focus({ preventScroll: !0 });
        });
        break;
      case f.Tab:
        a.preventDefault(), a.stopPropagation();
        break;
      default:
        a.key.length === 1 && (e.search(a.key), v.value = setTimeout(() => e.clearSearch(), 350));
        break;
    }
  }
  let p = oe(), c = m(() => p !== null ? (p.value & E.Open) === E.Open : e.listboxState.value === 0);
  return () => {
    var a, i;
    let P = { open: e.listboxState.value === 0 }, { ...w } = t, L = { "aria-activedescendant": e.activeOptionIndex.value === null || (a = e.options.value[e.activeOptionIndex.value]) == null ? void 0 : a.id, "aria-multiselectable": e.mode.value === 1 ? !0 : void 0, "aria-labelledby": (i = x(e.buttonRef)) == null ? void 0 : i.id, "aria-orientation": e.orientation.value, id: s, onKeydown: d, role: "listbox", tabIndex: 0, ref: e.optionsRef };
    return A({ ourProps: L, theirProps: w, slot: P, attrs: b, slots: y, features: U.RenderStrategy | U.Static, visible: c.value, name: "ListboxOptions" });
  };
} }), Ee = V({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(t, { slots: b, attrs: y, expose: h }) {
  var r;
  let s = (r = t.id) != null ? r : `headlessui-listbox-option-${j()}`, e = F("ListboxOption"), v = R(null);
  h({ el: v, $el: v });
  let d = m(() => e.activeOptionIndex.value !== null ? e.options.value[e.activeOptionIndex.value].id === s : !1), p = m(() => k(e.mode.value, { 0: () => e.compare(S(e.value.value), S(t.value)), 1: () => S(e.value.value).some((l) => e.compare(S(l), S(t.value))) })), c = m(() => k(e.mode.value, { 1: () => {
    var l;
    let o = S(e.value.value);
    return ((l = e.options.value.find((n) => o.some((u) => e.compare(S(u), S(n.dataRef.value))))) == null ? void 0 : l.id) === s;
  }, 0: () => p.value })), a = $(v), i = m(() => ({ disabled: t.disabled, value: t.value, get textValue() {
    return a();
  }, domRef: v }));
  M(() => e.registerOption(s, i)), G(() => e.unregisterOption(s)), M(() => {
    K([e.listboxState, p], () => {
      e.listboxState.value === 0 && p.value && k(e.mode.value, { 1: () => {
        c.value && e.goToOption(g.Specific, s);
      }, 0: () => {
        e.goToOption(g.Specific, s);
      } });
    }, { immediate: !0 });
  }), J(() => {
    e.listboxState.value === 0 && d.value && e.activationTrigger.value !== 0 && B(() => {
      var l, o;
      return (o = (l = x(v)) == null ? void 0 : l.scrollIntoView) == null ? void 0 : o.call(l, { block: "nearest" });
    });
  });
  function P(l) {
    if (t.disabled) return l.preventDefault();
    e.select(t.value), e.mode.value === 0 && (e.closeListbox(), B(() => {
      var o;
      return (o = x(e.buttonRef)) == null ? void 0 : o.focus({ preventScroll: !0 });
    }));
  }
  function w() {
    if (t.disabled) return e.goToOption(g.Nothing);
    e.goToOption(g.Specific, s);
  }
  let L = ee();
  function D(l) {
    L.update(l);
  }
  function T(l) {
    L.wasMoved(l) && (t.disabled || d.value || e.goToOption(g.Specific, s, 0));
  }
  function I(l) {
    L.wasMoved(l) && (t.disabled || d.value && e.goToOption(g.Nothing));
  }
  return () => {
    let { disabled: l } = t, o = { active: d.value, selected: p.value, disabled: l }, { value: n, disabled: u, ...O } = t, C = { id: s, ref: v, role: "option", tabIndex: l === !0 ? void 0 : -1, "aria-disabled": l === !0 ? !0 : void 0, "aria-selected": p.value, disabled: void 0, onClick: P, onFocus: w, onPointerenter: D, onMouseenter: D, onPointermove: T, onMousemove: T, onPointerleave: I, onMouseleave: I };
    return A({ ourProps: C, theirProps: O, slot: o, attrs: y, slots: b, name: "ListboxOption" });
  };
} });
export {
  Ve as Listbox,
  Ae as ListboxButton,
  Ee as ListboxOption,
  Fe as ListboxOptions
};
